<div [ngClass]="wfParent ? 'tw-block tw-p-4 md:tw-p-8' : ''">
  <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800 dark:tw-text-gray-100 tw-mt-0 tw-mb-6">
    My Account
  </h1>

  <div class="tw-max-w-xl tw-flex tw-flex-col tw-gap-6">
    <!-- Name (inline editable) -->
    <div>
      <div class="tw-text-sm tw-font-medium tw-text-gray-500 dark:tw-text-gray-400 tw-mb-1">
        Name
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <div
          contenteditable="true"
          class="name-edit tw-text-base tw-text-gray-800 dark:tw-text-gray-200 tw-min-w-[12rem] tw-max-w-full tw-rounded tw-px-1.5 tw-py-0.5 tw-cursor-text tw-border tw-border-dashed tw-border-transparent hover:tw-border-gray-400 focus:tw-border-gray-400 focus:tw-outline-none"
          [textContent]="name"
          (keydown)="onNameKeydown($event)"
          (blur)="saveName($event.target)"></div>
        <mat-spinner *ngIf="savingName" diameter="16"></mat-spinner>
        <mat-icon
          *ngIf="!savingName"
          class="tw-text-gray-400 tw-text-base tw-w-4 tw-h-4 tw-leading-4">
          edit
        </mat-icon>
      </div>
      <div class="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-mt-1">
        Click your name to edit it &mdash; it saves when you click away.
      </div>
    </div>

    <!-- Email (read-only) -->
    <div>
      <div class="tw-text-sm tw-font-medium tw-text-gray-500 dark:tw-text-gray-400 tw-mb-1">
        Email
      </div>
      <div class="tw-text-base tw-text-gray-800 dark:tw-text-gray-200 tw-px-1.5">{{ email }}</div>
    </div>

    <!-- Password -->
    <div
      class="tw-border-0 tw-border-t tw-border-solid tw-border-gray-200 dark:tw-border-gray-600 tw-pt-6">
      <div class="tw-text-sm tw-font-medium tw-text-gray-500 dark:tw-text-gray-400 tw-mb-1">
        Password
      </div>
      <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-mt-0 tw-mb-3">
        We'll email you a secure link to set a new password.
      </p>
      <button
        mat-raised-button
        color="primary"
        [disabled]="sendingReset || resetEmailSent"
        [class.spinner]="sendingReset"
        (click)="sendPasswordReset()">
        {{ resetEmailSent ? 'Email sent' : 'Send password reset email' }}
      </button>
      <div *ngIf="resetEmailSent" class="tw-text-sm tw-text-positive tw-mt-2">
        Check {{ email }} for the reset link.
      </div>
    </div>
  </div>
</div>
